'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _position = require('./position');

exports.default = function (droppable, point) {
  var closestScrollable = droppable.viewport.closestScrollable;
  if (!closestScrollable) {
    return point;
  }

  return (0, _position.add)(point, closestScrollable.scroll.diff.displacement);
};


//////////////////
// WEBPACK FOOTER
// /home/caligram/admin.caligram.com/shared/~/react-beautiful-dnd/lib/state/with-droppable-displacement.js
// module id = 197
// module chunks = 0